import axios from "../../config/axiosConfig";
import { DELIVERY_CHALLAN_TRANSACTION_REQUEST, DELIVERY_CHALLAN_TRANSACTION_REQUEST_FAILURE, GET_DELIVERY_CHALLAN_TRANSACTIONS_TAKA_NO,
  GET_DELIVERY_CHALLAN_TRANSACTIONS } from "../types";

export const getDeliveryChallanTransactions = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/delivery-challan-transaction/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLAN_TRANSACTIONS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDeliveryChallanTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_TRANSACTION_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/delivery-challan-transaction/getAllTakaNos", { params }).then((response) => {
        const takaNos = response.data.map((data) => data.Taka_No);
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLAN_TRANSACTIONS_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_TRANSACTION_REQUEST_FAILURE, error: error.message });
    }
  };
};

